


























import { computed, defineNuxtComponent } from '~/utils/nuxt3-migration'

export default defineNuxtComponent({
  inheritAttrs: true,
  components: {
    CNewBadge: () =>
      import('~/components/shared/configurable/badge/CNewBadge.vue')
  },
  props: {
    icon: {
      type: Object,
      default: null
    },
    iconSize: {
      type: [String, Number],
      default: '20'
    },
    active: {
      type: Boolean,
      default: false
    },
    newBadge: {
      type: Boolean,
      default: false
    },
    counter: {
      type: [Number, String],
      default: null
    },
    orangeCounter: {
      type: Boolean,
      default: false
    }
  },
  setup(_, { emit, attrs }) {
    const isLink = computed(() => {
      return attrs.href || attrs.to
    })

    function handleClick(e: Event) {
      emit('click', e)
    }

    return {
      isLink,
      handleClick
    }
  }
})
